import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';

interface Props {
  handleClickRequestButton: () => void;
}

const EmptySearchResult = ({ handleClickRequestButton }: Props) => {
  return (
    <Container>
      <Wrapper>
        <EmptyResultTitle>검색 결과가 없어요</EmptyResultTitle>
        <EmptyResultOffer>{`다른 탭의 정보를 찾아보세요.\n꼭 필요한 정보가 있다면 알려주세요.`}</EmptyResultOffer>
        <ButtonSection>
          <Button onClick={handleClickRequestButton}>정보 요청하기</Button>
        </ButtonSection>
      </Wrapper>
    </Container>
  );
};

export default EmptySearchResult;

const Container = styled.div`
  display: inline-grid;
  width: 100%;
  height: calc(100vh - 180px);
  text-align: center;
  align-items: center;
`;

const Wrapper = styled.div``;

const EmptyResultTitle = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI20SB};
    color: ${theme.color.gray600};
  `};

  margin-top: 20px;
`;

const EmptyResultOffer = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI15R}
    color: ${theme.color.gray400};
  `};

  margin: 8px 0 20px;
  white-space: pre-wrap;
`;

const ButtonSection = styled.div`
  justify-content: center;
  display: flex;
`;

const Button = styled(DefaultButtonStyled)`
  padding: 9px 20px;
  border-radius: 8px;

  ${({ theme }) => `
    ${theme.typography.UI15M};
    color: ${theme.color.primary700};
    background: ${theme.color.primary100};
  `}
`;
